export default __webpack_public_path__ + "static/social-top50-6ec25d829956a2642029d7a304547f30.png";